import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../components/ToastComponent/store/toastMiddleware';
import { type AppDispatch } from '../../../redux/store';
import {
  createNewLoan,
  getLoanTypes,
  searchLoanNumbers,
  getLoanByLoanNumber,
  getUnpledgedLoans,
  getUndisbursedLoans,
  updateUndisbursedLoan,
  getUnapprovedLoans,
  updateUnapprovedLoan,
  searchClosedLoanNumbers,
  getUnsettledPayments,
  updateUnsettledPayment,
  updateLoanPaymentSplit,
  getRecoveryLoans,
  getUnapprovedPayments,
  getReports,
  viewReports,
  updateLoanPrincipal
} from './loanMiddleware';
import { type CreateLoanRequest } from './loanTypes';
// import moment from 'moment';

export const createNewLoanAction = async (
  dispatch: AppDispatch,
  payload: CreateLoanRequest
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(createNewLoan(data));

  
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Loan Created Successfully'));
    
    return { ...res.payload.loan,interestTypePercentage: res.payload.loanPercentage, interestRates: res.payload.interestRates };
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error creating loan'));
    return false;
  }
};

export const getLoanTypesAction = async (
  dispatch: AppDispatch
) => {
  const res = await dispatch(getLoanTypes({}));
  console.log('res.data', res);
};

export const searchLoanNumbersAction = async (
  dispatch: AppDispatch,
  payload: string
) => {
  const res: any = await dispatch(searchLoanNumbers(payload));

  if (res.meta.requestStatus === 'fulfilled') {
    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error fetching loan numbers'));
    return false;
  }
};

export const searchClosedLoanNumbersAction = async (
  dispatch: AppDispatch,
  payload: string
) => {
  const res: any = await dispatch(searchClosedLoanNumbers(payload));

  if (res.meta.requestStatus === 'fulfilled') {
    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error fetching loan numbers'));
    return false;
  }
};

export const getLoanByLoanNumberAction = async (
  dispatch: AppDispatch,
  payload: string
) => {
  const res: any = await dispatch(getLoanByLoanNumber(payload));

  if (res.meta.requestStatus === 'fulfilled') {
    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error fetching loan numbers'));
    return false;
  }
};

export const getUnpledgedLoansAction = async (
  dispatch: AppDispatch,
  payload: { branch: string}
) => {
  const res = await dispatch(getUnpledgedLoans(payload));
  console.log(res);
};

export const getUndisbursedLoansAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getUndisbursedLoans(null));
  console.log(res);
};

export const updateUndisbursedLoanAction = async (
  dispatch: AppDispatch,
  payload: {id: string}
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(updateUndisbursedLoan(data));

  
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Loan updated Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating loan'));
    return false;
  }
};

export const getUnsettledPaymentsAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getUnsettledPayments(null));
  console.log(res);
};

export const getUnapprovedPaymentsAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getUnapprovedPayments(null));
  console.log(res);
};

export const updateUnsettledPaymentsAction = async (
  dispatch: AppDispatch,
  payload: {id: string, status: string}
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(updateUnsettledPayment(data));

  
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Loan updated Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating loan'));
    return false;
  }
};

export const updateLoanPaymentSplitAction = async (
  dispatch: AppDispatch,
  payload: {
    id: string;
    onlinePrincipal: number;
    offlinePrincipal: number;
    onlineInterest: number;
    offlineInterest: number;
  }
) => {
  const res: any = await dispatch(updateLoanPaymentSplit(payload));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Payment amounts updated Successfully'));
  } else {
    dispatch(
      showErrorMessage(
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        res.payload?.response?.data?.message || 'Error updating payment amounts'
      )
    );
    return false;
  }
};

export const getUnapprovedLoansAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getUnapprovedLoans(null));
  console.log(res);
};

export const getRecoveryLoansAction = async (
  dispatch: AppDispatch,
  payload: {branch: string, minDays: number | null, maxDays: number | null}
) => {
  const res = await dispatch(getRecoveryLoans(payload));
  console.log(res);
};

export const getReportsAction = async (
  dispatch: AppDispatch,
  payload: {branch: string, type: string, startDate: string, endDate: string}
) => {
  const res: any = await dispatch(getReports(payload));
  if (res.meta.requestStatus === 'rejected') {
    dispatch(showErrorMessage(String(res.payload?.response?.data?.message ?? 'Error fetching reports')));
  }
};

export const viewReportsAction = async (
  dispatch: AppDispatch,
  payload: {branch: string, type: string, startDate: string, endDate: string}
) => {
  const res: any = await dispatch(viewReports(payload));
  if (res.meta.requestStatus === 'rejected') {
    dispatch(showErrorMessage(String(res.payload?.response?.data?.message ?? 'Error fetching reports')));
    return null;
  }
  return res.payload;
};

export const updateUnapprovedLoanAction = async (
  dispatch: AppDispatch,
  payload: {id: string, status: string}
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(updateUnapprovedLoan(data));

  
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Loan updated Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating loan'));
    return false;
  }
};

export const updatePrincipalAmountAction = async (dispatch: any, payload: { id: string; onlinePrincipal?: number; offlinePrincipal?: number; onlineDocumentCharge?: number; offlineDocumentCharge?: number; onlineGstOnDocumentCharge?: number; offlineGstOnDocumentCharge?: number }) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(updateLoanPrincipal(data));

  
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Loan principal updated Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating loan principal'));
    return false;
  }
};